<template>
    <div class="d-flex radio align-items-center" @click="select()">
        <div class="flex-fill radio__label">
            <slot></slot>
        </div>
        <div>
            <span class="radio__switch" :class="[{ on: state }]"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        state: {
            type: Boolean,
            default: false,
        },
        groupKey: {
            type: String,
            default: '',
        },
        filterKey: {
            type: String,
            default: '',
        },
    },
    methods: {
        select() {
            this.$emit('input', true);
            this.$emit('change', {
                group: this.groupKey,
                filter: this.filterKey,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.radio {
    cursor: pointer;
}

.radio__label {
    color: #4e3a30;
    font-size: 18px;
    font-weight: 500;
}

.radio__switch {
    position: relative;
    display: block;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(78, 58, 48, 0.2);
    border-radius: 50%;

    &:before {
        position: absolute;
        content: '';
        width: 14px;
        height: 14px;
        display: block;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &.on {
        border-color: #c8532b;
        &:before {
            background-color: #c8532b;
        }
    }
}
</style>
